import React, { useEffect, useRef, useState } from 'react';
import { getApiBaseUrl } from "../utils/apiAssetUrl";
import '../CSS/Global.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { stripHtml } from '../utils/stringUtils';
import Header from './Header';
import noresult from "../Images/noresult.webp"
import { INDIA_DATA } from "./indiaStatesCities"
import siteLogo from "../Images/160X60-BIGBULL-PAISEWALA.png";

const SearchPage = () => {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]); // Store search results
    const navigate = useNavigate();
    const [storeAll, setStoreAll] = useState([]);
    const searchInputRef = useRef(null);
    const resultRef = useRef(null); // Reference for the results container
    const [nameQuery, setNameQuery] = useState('');
    const [pincodeQuery, setPincodeQuery] = useState('');
    const nameInputRef = useRef(null);
    const pincodeInputRef = useRef(null);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedState, setSelectedState] = useState("");
    const [selectedCity, setSelectedCity] = useState("");
    const [keyword, setKeyword] = useState("");
    const url = getApiBaseUrl();
    const resolveListingImageSrc = (imgPath) => {
        if (!imgPath) return siteLogo;
        if (imgPath.startsWith("http")) return imgPath;
        return `${url}/${imgPath}`;
    };

    const handleListingImageError = (e) => {
        const target = e.currentTarget;
        if (!target || target.dataset?.fallbackApplied === "true") return;
        if (target.dataset) target.dataset.fallbackApplied = "true";
        target.src = siteLogo;
        target.style.opacity = "0.5";
    };


    const [ratingsSummary, setRatingsSummary] = useState({});

    const getStoreCreatedAtTs = (store) => {
        const candidate =
            store?.createdAt ||
            store?.created_at ||
            store?.createdDate ||
            store?.created_date ||
            store?.created_on ||
            store?.created_on_date;

        const ts = candidate ? new Date(candidate).getTime() : NaN;
        if (!Number.isNaN(ts)) return ts;

        // Fallback: if no created timestamp exists, try numeric id
        const idNum = Number(store?.id || store?.storeId || 0);
        return Number.isFinite(idNum) ? idNum : 0;
    };

    const sortStoresLatestFirst = (arr) => {
        if (!Array.isArray(arr)) return [];
        return [...arr].sort((a, b) => getStoreCreatedAtTs(b) - getStoreCreatedAtTs(a));
    };

    // -------------------------
    // 1. LOAD ALL STATES OF INDIA
    // -------------------------
    useEffect(() => {
        setStates(INDIA_DATA); // load all states
    }, []);



    const handleStateChange = (e) => {
        const stateId = Number(e.target.value);
        setSelectedState(stateId);

        const state = INDIA_DATA.find(s => s.id === stateId);

        setCities(state ? state.cities : []);
        setSelectedCity("");
    };



    const handleSearch = () => {
        console.log("Searching for:", {
            selectedState,
            selectedCity,
            keyword,
        });

        // CALL YOUR SEARCH API HERE
    };

    const handleSearchChange = (event) => {
        setQuery(event.target.value);
    };

    useEffect(() => {
        if (nameInputRef.current) {
            nameInputRef.current.focus();
        }
    }, []);

    const fetchDataAll = async () => {
        try {
            const response = await axios.get(`${getApiBaseUrl()}/store/allstorelist/allstore/adsfk1367tyh`);
            const parsedResults = response.data
                .filter((store) => store.status === "Active") // Check for "Active" status
                .map((store) => ({
                    ...store,
                    additionalEmails: JSON.parse(store.additionalEmails || "[]"),
                    additionalLandlines: JSON.parse(store.additionalLandlines || "[]"),
                    additionalMobiles: JSON.parse(store.additionalMobiles || "[]"),
                    additionalServices: JSON.parse(store.additionalServices || "[]"),
                    additionalWhatsapps: JSON.parse(store.additionalWhatsapps || "[]"),
                    businessDetails: JSON.parse(store.businessDetails || "{}"),
                    businessTiming: JSON.parse(store.businessTiming || "{}"),
                    contactDetails: JSON.parse(store.contactDetails || "{}"),
                    formImages: JSON.parse(store.formImages || "[]"),
                    paymentDetails: JSON.parse(store.paymentDetails || "{}"),
                    servicesDetails: JSON.parse(store.servicesDetails || "{}"),
                }));
            console.log(parsedResults);
            setStoreAll(sortStoresLatestFirst(parsedResults));
        } catch (error) {
            console.error("Error fetching stores:", error);
        }
    };

    const fetchStores = async () => {
        try {
            const response = await axios.get(`${getApiBaseUrl()}/store/getstore/search`, {
                params: { name: nameQuery, pincode: pincodeQuery },
            });
            const parsedResults = response.data
                .filter((store) => store.status === "Active")
                .map((store) => ({
                    ...store,
                    additionalEmails: JSON.parse(store.additionalEmails || "[]"),
                    additionalLandlines: JSON.parse(store.additionalLandlines || "[]"),
                    additionalMobiles: JSON.parse(store.additionalMobiles || "[]"),
                    additionalServices: JSON.parse(store.additionalServices || "[]"),
                    additionalWhatsapps: JSON.parse(store.additionalWhatsapps || "[]"),
                    businessDetails: JSON.parse(store.businessDetails || "{}"),
                    businessTiming: JSON.parse(store.businessTiming || "{}"),
                    contactDetails: JSON.parse(store.contactDetails || "{}"),
                    formImages: JSON.parse(store.formImages || "[]"),
                    paymentDetails: JSON.parse(store.paymentDetails || "{}"),
                    servicesDetails: JSON.parse(store.servicesDetails || "{}"),
                }));

            setStoreAll(sortStoresLatestFirst(parsedResults));
        } catch (error) {
            console.error("Error fetching stores:", error);
        }
    };


    // useEffect(() => {



    //         fetchStores();

    // }, [nameQuery, ]);


    const getFilteredStores = () => {
        const filtered = storeAll.filter(store => {

            const businessName = store.businessDetails.businessName?.toLowerCase() || "";
            const service = store.servicesDetails.service?.toLowerCase() || "";
            const category = store.category?.toLowerCase() || "";
            const subcategory = store.subcategory?.toLowerCase() || "";
            const city = store.businessDetails.city?.toLowerCase() || "";
            const state = store.businessDetails.state?.toLowerCase() || "";
            const pin = store.businessDetails.pincode || "";

            // --- STATE MATCH ---
            const stateMatch = selectedState
                ? state === states.find(s => s.id === selectedState)?.name.toLowerCase()
                : true;

            // --- CITY MATCH ---
            const cityMatch = selectedCity
                ? city === selectedCity.toLowerCase()
                : true;

            // --- KEYWORD MATCH ---
            const keywordMatch = keyword
                ? (
                    businessName.includes(keyword.toLowerCase()) ||
                    category.includes(keyword.toLowerCase()) ||
                    service.includes(keyword.toLowerCase())
                )
                : true;



            // --- NAME MATCH ---
            const nameMatch = nameQuery
                ? businessName.includes(nameQuery.toLowerCase())
                : true;

            // --- PINCODE MATCH ---
            const pincodeMatch = pincodeQuery
                ? pin === pincodeQuery
                : true;

            return stateMatch && cityMatch && keywordMatch && nameMatch && pincodeMatch;
        });

        return sortStoresLatestFirst(filtered);
    };


    const handleSearchClick = () => {
        if (nameQuery || pincodeQuery) {
            fetchStores();
        } else {
            fetchDataAll();
        }
    };

    useEffect(() => {


        fetchDataAll();
    }, []);


    // Close results when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (resultRef.current && !resultRef.current.contains(event.target) && !searchInputRef.current.contains(event.target)) {
                setQuery(''); // Clear the query to hide results
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const filteredStores = getFilteredStores();

    // Fetch ratings summary for stores in the background
    useEffect(() => {
        const storesToFetch = filteredStores
            .map((s) => s.user_id)
            .filter(Boolean)
            .filter((storeId) => typeof ratingsSummary[storeId] === "undefined");

        if (storesToFetch.length === 0) return;

        let cancelled = false;
        Promise.all(
            storesToFetch.map(async (storeId) => {
                try {
                    const response = await axios.get(`${url}/rating/summary/${storeId}`);
                    const res = response.data;
                    return { storeId, res };
                } catch (e) {
                    return { storeId, res: { isError: true } };
                }
            })
        ).then((results) => {
            if (cancelled) return;
            setRatingsSummary((prev) => {
                const next = { ...prev };
                results.forEach(({ storeId, res }) => {
                    if (!res || res.isError) return;
                    next[storeId] = {
                        count: res.count || 0,
                        average: res.average || 0,
                    };
                });
                return next;
            });
        });

        return () => {
            cancelled = true;
        };
    }, [filteredStores, ratingsSummary, url]);


    return (
        <>
            <Header />
            <div className="sub-category-page-header">
                <div
                    className='back-btn-navigate'
                    onClick={() => navigate(-1)}
                    title='Go back'
                >
                    <i className="fa-solid fa-arrow-left"></i>
                </div>
                <div className='sub-category-heading'>Search Services/Listings</div>
                <div></div>
            </div>
            <div className="sub-category-page-search">
                {/* <i className="fa fa-search search-page-icon"></i> */}
                <div className="big-search-bar">

                    {/* STATE DROPDOWN */}
                    <select value={selectedState} onChange={handleStateChange} className="search-select">
                        <option value="">Select State</option>

                        {states.map((state) => (
                            <option key={state.id} value={state.id}>
                                {state.name}
                            </option>
                        ))}
                    </select>



                    {/* CITY DROPDOWN */}
                    <select value={selectedCity} onChange={(e) => setSelectedCity(e.target.value)} disabled={!selectedState} className="search-select">
                        <option value="">Select City</option>

                        {cities.map((city, index) => (
                            <option key={index} value={city}>
                                {city}
                            </option>
                        ))}
                    </select>



                    {/* KEYWORD INPUT */}
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Category / Keywords"
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                    />

                    {/* SEARCH BUTTON */}
                    <button className="main-search-btn" onClick={handleSearch}>
                        Search
                    </button>
                </div>
            </div>



            <div className="search-cards-page">
                {filteredStores.length > 0 ? (
                    filteredStores.map((item, index) => (
                        <div className="bigbull-card" key={index}>
                            <div className="card-body">
                                <div
                                    className="card-body-img"
                                    onClick={() => navigate(
                                        `/detail-listing/${item.id}/${item.businessDetails?.businessName}`
                                    )}
                                >
                                    <img
                                        src={
                                            resolveListingImageSrc(item.formImages?.[0])
                                        }
                                        alt={item.businessDetails?.businessName || "Store image"}
                                        onError={handleListingImageError}
                                    />
                                </div>
                                <p
                                    className="store-name"
                                    onClick={() => navigate(
                                        `/detail-listing/${item.id}/${item.businessDetails?.businessName}`
                                    )}
                                >
                                    {item.businessDetails.businessName}
                                </p>
                                <p
                                    className="store-category"
                                    onClick={() => navigate(
                                        `/detail-listing/${item.id}/${item.businessDetails?.businessName}`
                                    )}
                                >
                                    {(item.subcategory && String(item.subcategory).trim()) || item.category || '—'}
                                </p>
                                <p
                                    className="store-description"
                                    onClick={() => navigate(
                                        `/detail-listing/${item.id}/${item.businessDetails?.businessName}`
                                    )}
                                >
                                    {(stripHtml(item.businessDetails?.description || '') || '—').slice(0, 50)}
                                    {(stripHtml(item.businessDetails?.description || '')?.length || 0) > 50 ? '...' : ''}
                                </p>
                                <p
                                    className="store-timing"
                                    onClick={() => navigate(
                                        `/detail-listing/${item.id}/${item.businessDetails?.businessName}`
                                    )}
                                >
                                    {item.businessTiming?.timeSlots?.[0]
                                        ? `${item.businessTiming.timeSlots[0].day || ''}: ${item.businessTiming.timeSlots[0].openTime || '—'} - ${item.businessTiming.timeSlots[0].closeTime || '—'}`
                                        : '—'}
                                </p>
                                <p
                                    className="rating"
                                    onClick={() => navigate(
                                        `/detail-listing/${item.id}/${item.businessDetails?.businessName}`
                                    )}
                                >
                                    <span className='rating-average'>
                                        {ratingsSummary[item.user_id]?.average ?? 0}{' '}
                                    </span>
                                    <i className="fa-solid fa-star"></i>{' '}
                                    <span className='no-of-ratings'>
                                        {ratingsSummary[item.user_id]?.count ?? 0} Ratings
                                    </span>
                                </p>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="no-results">
                        <img src={noresult} alt="No results found" className="no-results-image" />
                        <p className="no-results-text">No store found</p>
                    </div>
                )}
            </div>
        </>
    );
};

export default SearchPage;




































































// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import '../CSS/Global.css';
// import { useNavigate } from 'react-router-dom';

// const SearchPage = () => {
//     const [query, setQuery] = useState('');
//     const [results, setResults] = useState([]); // Store search results
//     const navigate = useNavigate()

//     const handleSearchChange = (event) => {
//         setQuery(event.target.value);
//     };

//     useEffect(() => {
//         // Fetch stores whenever the query changes
//         const fetchStores = async () => {
//             try {
//                 const response = await axios.get(${getApiBaseUrl()}/store/getstore/search, {
//                     params: { name: query },
//                 });

//                 // console.log(response);
//                 const parsedResults = response.data.map((store) => {
//                     return {
//                         ...store,
//                         additionalEmails: JSON.parse(store.additionalEmails || "[]"),
//                         additionalLandlines: JSON.parse(store.additionalLandlines || "[]"),
//                         additionalMobiles: JSON.parse(store.additionalMobiles || "[]"),
//                         additionalServices: JSON.parse(store.additionalServices || "[]"),
//                         additionalWhatsapps: JSON.parse(store.additionalWhatsapps || "[]"),
//                         businessDetails: JSON.parse(store.businessDetails || "{}"),
//                         businessTiming: JSON.parse(store.businessTiming || "{}"),
//                         contactDetails: JSON.parse(store.contactDetails || "{}"),
//                         formImages: JSON.parse(store.formImages || "[]"),
//                         paymentDetails: JSON.parse(store.paymentDetails || "{}"),
//                         servicesDetails: JSON.parse(store.servicesDetails || "{}"),
//                     };
//                 });
//                 console.log(parsedResults);
//                 setResults(parsedResults);
//             } catch (error) {
//                 console.error("Error fetching stores:", error);
//             }
//         };
//         if (query) {
//             fetchStores();
//         } else {
//             setResults([]); // Clear results if query is empty
//         }
//     }, [query]);

//     return (
//         <div className="search-page">
//             <input
//                 type="text"
//                 placeholder="Search for store..."
//                 className="search-page__input"
//                 value={query}
//                 onChange={handleSearchChange}
//             />

//         </div>
//     );
// };

// export default SearchPage;